"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _reactJss = _interopRequireDefault(require("react-jss"));

var _clsx = _interopRequireDefault(require("clsx"));

var _NotifyItem = _interopRequireDefault(require("./NotifyItem.style"));

var _Icon = _interopRequireDefault(require("../../Icon"));

var _Label = _interopRequireDefault(require("../../Label"));

var _dec, _class;

const AUTO_HIDE_TIMEOUT = 5000;
let NotifyItem = (_dec = (0, _reactJss.default)(_NotifyItem.default), _dec(_class = class NotifyItem extends _react.PureComponent {
  constructor(props) {
    super(props);
    this.handleClose = this.handleClose.bind(this);
  }

  handleClose() {
    const {
      onClose,
      id
    } = this.props;
    onClose({
      id
    });
  }

  componentDidMount() {
    setTimeout(this.handleClose, AUTO_HIDE_TIMEOUT);
  }

  render() {
    const {
      id,
      classes,
      className,
      label,
      icon,
      type,
      helperText
    } = this.props;
    return _react.default.createElement("div", {
      id: id,
      className: (0, _clsx.default)(classes.notifyItem, classes[type], className)
    }, _react.default.createElement("div", {
      className: (0, _clsx.default)(classes.titleContainer)
    }, icon ? _react.default.createElement(_Icon.default, {
      className: classes.icon,
      type: icon,
      size: "medium",
      color: 'currentColor'
    }) : null, _react.default.createElement(_Label.default, {
      className: (0, _clsx.default)(classes.title),
      value: label,
      fontSize: "medium"
    }), _react.default.createElement(_Icon.default, {
      className: (0, _clsx.default)(classes.closeIcon),
      type: "close",
      size: "micro",
      color: 'currentColor',
      onClick: this.handleClose
    })), helperText ? _react.default.createElement("div", {
      className: (0, _clsx.default)(classes.descriptionContainer)
    }, _react.default.createElement(_Label.default, {
      className: (0, _clsx.default)(classes.description),
      value: helperText,
      fontSize: "medium"
    })) : null);
  }

}) || _class);
NotifyItem.defaultProps = {
  type: 'normal',
  onClose: () => {}
};
var _default = NotifyItem;
exports.default = _default;